import { render, staticRenderFns } from "./myGame.vue?vue&type=template&id=b97a6530&"
import script from "./myGame.vue?vue&type=script&lang=js&"
export * from "./myGame.vue?vue&type=script&lang=js&"
import style0 from "./myGame.vue?vue&type=style&index=0&id=b97a6530&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports